<div class="reg-container">
  <span class="reg-text"><ng-content></ng-content></span>
</div>
